import request from '@/request'
import qs from 'qs'
// 获取查询类型下拉数据
export async function getCount() {
  return request({
    url: `/api/sys/v1/sys/sysNotify/count`,
    method: 'GET'
  })
}
// 获取查询类型下拉数据
export async function getSelectData() {
  return request({
    url: `/api/sys/v1/sys/sysNotifyInfo/selectData`,
    method: 'GET'
  })
}

// 个人信息
export async function getPersonData(params) {
  return request({
    url: `/api/sys/v1/sys/sysNotify/${params.id}`,
    method: 'GET'
  })
}

// 表格列表
export async function getListData(params) {
  const data = qs.stringify(params, { arrayFormat: 'brackets' })
  return request({
    url: `/api/sys/v1/sys/sysNotify?${data}`,
    method: 'GET'
  })
}

// 标记为已读
export async function getMarkRead(params) {
  // const data = qs.stringify(params, { arrayFormat: 'repeat' })
  return request({
    url: `/api/sys/v1/sys/sysNotify/readAllBody`,
    method: 'PUT',
    data: params
  })
}

// 批量删除
export async function deleteBatch(params) {
  // const data = qs.stringify(params, { arrayFormat: 'repeat' })
  return request({
    url: `/api/sys/v1/sys/sysNotify/deleteBatchNotifyBody`,
    method: 'DELETE',
    data: params
  })
}

// 附件信息
export async function getFileInfo(id, params) {
  const data = qs.stringify(params, { arrayFormat: 'brackets' })
  return request({
    url: `/api/oss/v2/oss/filerecord/${id}/info?${data}`,
    method: 'GET'
  })
}
